---
label: Storage
category: files-and-storage
icon: DatabaseIcon
keywords: [storage, quota, limit, space, persistent, browser, reset, clear, delete, fresh, factory, wipe]
addedInVersion: "0.0.0"
---

# Storage

Gnomux stores all your data locally in the browser. There is no cloud sync —
your sequences, alignments, and collections live on your device.

## Quota and Persistence

Browsers limit how much data a site can store. The exact amount depends on
your browser and available disk space.

On first use, Gnomux requests persistent storage from the browser. If granted,
your data won't be automatically cleared when disk space runs low.

You can check usage, quota, and persistence status in
[Storage Settings](/settings/storage). You can also set a storage limit there
to get a warning when you exceed a chosen threshold.

## Reset

Reset deletes all local data and returns Gnomux to a fresh state. This removes
all files, sequences, alignments, collections, and settings. It cannot be undone.

Find the reset option at the bottom of [Storage Settings](/settings/storage).
